import { BaseSyntheticEvent } from 'react'
import { DateRange } from '@mui/lab/DateRangePicker'
import { MenuItem, Typography } from '@mui/material'
import { IDateFilterVar } from 'context'
import { format } from 'date-fns'
import { compact } from 'lodash-es'
import { YYYY_MM_DD } from 'utility/timeFormats'
import { DateQuickFilters, getDateRange } from './helper'
import { IDateQuickFilterLabel } from './types'

interface IDateRangeQuickFilters {
  closePopover: () => void
  quickFilterOptions: { [key: number]: IDateQuickFilterLabel }
  setSelectedQuickFilter: (selectedQuickFilter: DateQuickFilters) => void
  customQuickFilter: string
  dateRange: DateRange<Date>
  changeDate: (selectedQuickFilter: DateQuickFilters, dateFilter: IDateFilterVar) => void
}

export const DateRangeQuickFilters = ({
  closePopover,
  quickFilterOptions,
  customQuickFilter,
  dateRange,
  changeDate
}: IDateRangeQuickFilters) => {
  const handleCustomOptionChange = (type: DateQuickFilters) => {
    const customQuickFilterRange = customQuickFilter.split(' - ')
    const nextDates = customQuickFilterRange.map((date) => new Date(date))

    const dateFilter = getDateRange(DateQuickFilters.DEFINED, [nextDates[0], nextDates[1]])
    changeDate(type, dateFilter)
  }

  const handleAllTimeOptionChange = (type: DateQuickFilters) => {
    changeDate(type, {
      startDate: format(new Date(), YYYY_MM_DD),
      endDate: format(new Date(), YYYY_MM_DD)
    })
  }

  const handleSelectChange = (e: BaseSyntheticEvent) => {
    closePopover()
    const type = e.target.value

    if (type === DateQuickFilters.DEFINED) {
      handleCustomOptionChange(type)
      return
    }

    if (type === DateQuickFilters.ALL_TIME) {
      handleAllTimeOptionChange(type)
      return
    }

    changeDate(type, getDateRange(type, compact([...dateRange])))
  }

  return (
    <>
      <Typography color="initial" sx={{ fontWeight: 500 }}>
        Quick filters
      </Typography>
      {Object.values(quickFilterOptions).map(({ label, value }) => (
        <MenuItem sx={{ paddingLeft: 1 }} key={value} value={value} onClick={handleSelectChange}>
          {label}
        </MenuItem>
      ))}
    </>
  )
}
